import { computed } from 'vue';
import useGlobalStyleStore from '../stores/globalStyle';

const useCurrentGlobalStyle = () => {
  const globalStyleStore = useGlobalStyleStore();
  return computed(() => globalStyleStore.getGlobalStyle);
};

export default useCurrentGlobalStyle;
